import { CaptureClicksRichText } from '@/features/shared';
import { MuiTypography } from '@/features/shared/material-ui';
import { PictureAsPdf as PictureAsPdfIcon } from '@material-ui/icons';
import clsx from 'clsx';
import React, { memo } from 'react';
import { HeaderContentProps } from './HeaderContent.interface';
import useStyles from './HeaderContent.styles';

const HeaderContent = ({
  title,
  shortDescription,
  publicationDate,
  location,
  pdf,
  downloadIcon,
  downloadLabel = 'Download',
  theme,
}: HeaderContentProps) => {
  const classes = useStyles({});

  const downloadEl = downloadIcon ? (
    <img src={downloadIcon} alt="" />
  ) : (
    <PictureAsPdfIcon fontSize="small" />
  );

  const rootClassName = clsx(classes.root, `${theme}-theme`);

  return (
    <div className={rootClassName}>
      <MuiTypography variant="h1" className={classes.heading}>
        {title}
      </MuiTypography>
      {shortDescription && (
        <CaptureClicksRichText
          theme={theme}
          containerProps={{ className: classes.description }}
          content={shortDescription}
        />
      )}
      <div className={classes.info}>
        <MuiTypography variant="subtitle1" className={classes.locationPublication}>
          {location}
          {location && publicationDate && ', '}
          {publicationDate}
        </MuiTypography>
        {pdf && <span className={classes.separator}>|</span>}
        {pdf && (
          <a href={pdf?.url} aria-label={downloadLabel} className={classes.downloadIcon} download>
            {downloadEl}
          </a>
        )}
      </div>
    </div>
  );
};

export default memo(HeaderContent);
